import { useMutation } from '@apollo/client';

import { UpdateClientContactInput } from '__generated__/GQL';

import { ClientContactForm } from '../../components/FormModal/hooks/useClientFormModalContext';
import { refetchGetClient } from '../useGetClient';
import { trimClientContactNames } from '../utils';
import { UpdateClientContactDocument } from './graphql/updateClientContact.gql';

export const useUpdateClientContact = (clientId: string) => {
  const [mutation, result] = useMutation(UpdateClientContactDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [refetchGetClient(clientId)],
  });

  const updateClientContact = (clientContact: ClientContactForm) => {
    const input: UpdateClientContactInput = {
      ...trimClientContactNames(clientContact),
      clientId,
    };
    return mutation({ variables: { input } });
  };

  return { updateClientContact, ...result };
};
